<template>
  <v-dialog
    v-model="showDialog"
    width="600"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="isSimpleListTags"
        class="px-5"
        v-bind="attrs"
        v-on="on"
        outlined
        small
        @click="showDialog = true"
        style="text-transform: none;"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ isSimpleListTags }}
      </v-btn>

      <v-btn
        v-else
        class="px-5"
        v-bind="attrs"
        v-on="on"
        small
        rounded
        outlined
        text
        @click="showDialog = true"
        style="text-transform: none;"
      >
        {{ $t("seeTags") }} ({{ listTags.length }})
      </v-btn>
    </template>

    <v-card>
      <v-toolbar elevation="0">
        <v-toolbar-title>{{
          isSimpleListTags
            ? isSimpleListTags
            : $t("yourTags")
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="showDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <div v-if="canRemoveTags && !isSimpleListTags" class="d-flex ma-6 mb-0">
        <v-checkbox
          v-model="removeTagsView"
          class="mt-0 py-0"
          hide-details
        ></v-checkbox>

        <div>{{ $tc("removeTags", 2) }}</div>
      </div>

      <v-card-text
        class="d-flex flex-wrap pa-6 pt-0 mt-6 scroll"
        style="max-height: 328px;"
      >
        <div
          v-for="(tag, index) in listTags"
          :key="index"
          class="rounded-pill py-1 px-3 mr-2 mb-2 d-flex align-center"
          @click="handleSelectTag(tag)"
          style="
            width: fit-content;
            height: min-content;
            white-space: nowrap;
          "
          :style="{
            'color': 'white',
            'border': '2px solid ' + tag.color,
            cursor: removeTagsView ? 'pointer' : 'default',
            ...(removeTagsView && selectedListTags[tag.id] ? {
              'background-color': tag.color,
            } : {
              'background-color': tag.color + '80',
            }),
          }"
        >
          {{ tag.title }}

          <v-icon
            v-if="removeTagsView"
            class="ml-2"
            small
          >
            mdi-close
          </v-icon>
        </div>
      </v-card-text>

      <v-card-actions class="pa-6">
        <v-spacer></v-spacer>

        <div v-if="removeTagsView">
          <v-btn
            class="px-4 mr-4"
            outlined
            @click="removeTagsView = false"
            style="text-transform: none;"
          >
            {{ $t("comeBack") }}
          </v-btn>

          <DialogConfirmRemoveTags
            :selectedTags="Object.values(selectedListTags)"
            @emitUpdateListTags="emitUpdateListTags"
          />
        </div>

        <v-btn
          v-else
          class="px-7"
          color="primary"
          v-on:click.prevent="showDialog = false;"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogConfirmRemoveTags from "../DialogConfirmRemoveTags/index.vue";

export default {
  name: "SeeTags",

  props: ["listTags", "isSimpleListTags"],

  components: { DialogConfirmRemoveTags },

  data: () => ({
    showDialog: false,
    removeTagsView: false,
    currentListTags: [],
    selectedListTags: {},
  }),

  watch: {
    showDialog(showDialog) {
      if (showDialog) {
        this.removeTagsView = false;
        this.currentListTags = [];

        this.currentListTags.push(...this.listTags);
      }
    },
    removeTagsView() {
      this.selectedListTags = {};
    },
  },

  computed: {
    canRemoveTags() {
      return this.$permission("142");
    },
  },

  methods: {
    handleSelectTag(tag) {
      if (this.selectedListTags[tag.id]) {
        this.$delete(this.selectedListTags, tag.id);
      } else {
        this.$set(this.selectedListTags, tag.id, tag);
      }
    },
    emitUpdateListTags() {
      this.$emit("updateListTags");

      this.showDialog = false;
    },
  },
}
</script>

<style scoped>
.scroll {
  overflow-y: auto;
  -ms-overflow-style: none;
  scroll-behavior: smooth;
}
</style>